/* tslint:disable */
import { Units } from './units';

/**
 */
export class ListUnit {
    name?: string;
    value?: number;
    SYMBOL?: string;
    COEFF_A?: number;
    COEFF_B?: number;
    symbolSelect?: Units;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/list-unit.ts